import * as React from 'react';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import SkillMapDetailContainer from '../../containers/SkillMapDetail';
import i18n from '../../resources/i18n';
const SkillMapDetail: React.SFC<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('SkillMapDetail_0018')} />
			<SkillMapDetailContainer {...props} />
		</>
	);
};

export default SkillMapDetail;



// WEBPACK FOOTER //
// ./src/pages/personal/SkillMapDetail.tsx